import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

/**
 * The carrier account of a return run's project: what went out, what has come back, what is still
 * on site.
 *
 * Both sides read the ledger here, unlike the articles. `loadCarrierStockTransactions` has carried
 * `suborderId` since the domain was built, so the outbound figure is complete without falling back
 * to a document total.
 */
export function useReturnCarrierReconciliation(returnOrderId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["return-order", guardString(returnOrderId), "carrier-reconciliation"],
		queryFn: async () => {
			const response = await client.stock["return-orders"][":returnOrderId"][
				"carrier-reconciliation"
			].$get({ param: { returnOrderId: guardString(returnOrderId) } });
			const data = await responseHandler(response, false);
			return data.reconciliation;
		},
		enabled: !!returnOrderId,
	});

	/** Return */
	return { ...query, reconciliation: query.data };
}
